import API from '../api/apiUtils/api2';

const cashValueAPI = new API({ url: `${process.env.REACT_APP_DOMAIN}/api/cvl` });

cashValueAPI.createEntities([{ name: 'requestCashValueLetter' }]);

const RequestCashValueLetter = (body) => cashValueAPI.endpoints.requestCashValueLetter.post(body);

export { RequestCashValueLetter };
